import { useTranslation } from "react-i18next";
import homerunPet from "@/assets/HomerunPet.png";
import toccaPet from "@/assets/ToccaPet.png";

const clients = [
  { name: "Bruna Vize", logo: "https://static.wixstatic.com/media/df8cc4_9840e529fab9446fa1e655d60c1c70cb~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_9840e529fab9446fa1e655d60c1c70cb~mv2.png", url: "https://www.instagram.com/bruna.vize/" },
  { name: "Prof Cintia Araújo", logo: "https://static.wixstatic.com/media/df8cc4_c1561e0d860446f4804e001f6f16adab~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_c1561e0d860446f4804e001f6f16adab~mv2.png", url: "https://www.instagram.com/profcintiaaraujo/" },
  { name: "Dr Fernando Frederico", logo: "https://static.wixstatic.com/media/df8cc4_cdbde2a90e1b41bfa139583ae02e2964~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_cdbde2a90e1b41bfa139583ae02e2964~mv2.png", url: "https://www.instagram.com/drfernandofrederico/" },
  { name: "Dra Soraia Cristina", logo: "https://static.wixstatic.com/media/df8cc4_9abbb47470114f25a24a91e10216a61d~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_9abbb47470114f25a24a91e10216a61d~mv2.png", url: "https://www.instagram.com/drasoraiacristinaaa/" },
  { name: "Elizabeth C Pimentel", logo: "https://static.wixstatic.com/media/df8cc4_eba55f5124df4af9a80117c9dd1646a6~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_eba55f5124df4af9a80117c9dd1646a6~mv2.png", url: "https://www.instagram.com/elizabethcpimentel/" },
  { name: "Dra Talitha Fagundes", logo: "https://static.wixstatic.com/media/df8cc4_8bc6e4bf65a04c6eba68c0fb57b61740~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_8bc6e4bf65a04c6eba68c0fb57b61740~mv2.png", url: "https://www.instagram.com/dratalithafagundes/" },
  { name: "Dra Vanessa Rodrigues", logo: "https://static.wixstatic.com/media/df8cc4_ec07fb45d37a4b9f94d67499bfe39464~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_ec07fb45d37a4b9f94d67499bfe39464~mv2.png", url: "https://www.instagram.com/dravanessarodriguesss/" },
  { name: "Dara Ferreira Fisio", logo: "https://static.wixstatic.com/media/df8cc4_49216ddc7919400487530f64d4a97da9~mv2.png/v1/fill/w_287,h_287,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/df8cc4_49216ddc7919400487530f64d4a97da9~mv2.png", url: "https://www.instagram.com/daraferreirafisio/" },
  { name: "HomerunPet", logo: homerunPet, url: "https://www.instagram.com/homerunpet_brasil/" },
  { name: "Tocca Pet Distribuidora", logo: toccaPet, url: "https://www.instagram.com/toccapetdistribuidora/" },
];

const ClientsSection = () => {
  const { t } = useTranslation();

  return (
    <section id="clientes" className="relative py-24 md:py-32">
      <div className="gradient-line mb-24 md:mb-32" />
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="text-center max-w-xl mx-auto">
          <p className="text-sm font-body font-medium text-primary uppercase tracking-wide flex items-center justify-center gap-2">
            <span className="led" />
            {t("clientsSection.tag")}
          </p>
          <h2 className="mt-3 text-3xl md:text-4xl font-display font-bold tracking-display text-foreground">
            {t("clientsSection.title")}
          </h2>
          <p className="mt-4 text-base font-body text-muted-foreground">
            {t("clientsSection.subtitle")}
          </p>
        </div>
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {clients.map((client) => (
            <a key={client.name} href={client.url} target="_blank" rel="noopener noreferrer" className={`group glass glass-shine rounded-2xl p-4 flex flex-col items-center gap-3 transition-all duration-300 ease-project hover:shadow-neon-sm hover:border-primary/30${client.name === "HomerunPet" ? " md:hidden lg:flex" : ""}`}>
              <img
                src={client.logo}
                alt={client.name}
                className={`w-24 h-24 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-xl transition-transform duration-300 group-hover:scale-110 ${
                  client.name === "HomerunPet" || client.name === "Tocca Pet Distribuidora"
                    ? "object-contain p-2"
                    : "object-cover"
                }`}
                loading="lazy"
              />
              <p className="text-xs font-body text-muted-foreground text-center group-hover:text-primary transition-colors duration-300">{client.name}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
